<div class="modal-header">
    <div class="w-100 d-flex align-items-center justify-content-between">
        <h5 class="m-0">{{title}}</h5>
        <div class="d-flex align-items-center gap-1">
            <ng-content></ng-content>
            <button *ngIf="close" class="btn-close" (click)="closed.emit(); bsModalRef.hide();"></button>
        </div>
    </div>
</div>